module.exports = __webpack_public_path__ + "static/media/emj17.4f9ce671.svg";